import ArticleImage from './ArticleImage';

export default ArticleImage;
